import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'ecp-tool-bar',
    templateUrl: './tool-bar.component.html',
    styleUrls: ['./tool-bar.component.css']
})
export class ToolBarComponent implements OnInit {

    constructor() {
    }

    @Input() customX;
    @Input() customY;
    @Input() customStyle: object = {};

    @Output() selectId: EventEmitter<string> = new EventEmitter();

    menuJSON = [{
        'name': 'æ·»å åç´ ',
        'url': 'http://www.google.com',
        'chird': [
            {
                'name': 'åæ ',
                'url': 'add_point'
            },
            {
                'name': 'ä¼ æå¨',
                'url': 'add_sensor'
            },
            {
                'name': 'ç®¡é',
                'url': 'add_pipe'
            },
            {
                'name': 'èç¹',
                'url': 'add_node'
            },
            {
                'name': 'å µå¤´å°æ¿',
                'url': 'add_plug'
            },
            {
                'name': 'é¸é',
                'url': 'add_valve'
            },
            {
                'name': 'æ¶é²æ ',
                'url': 'add_hydrant'
            }
        ]
    }, {
        'name': 'ç­æ¥',
        'url': 'screening',
        'chird': null
    }, {
        'name': 'é¢è­¦',
        'url': 'http://www.google.com',
        'chird': [
            {
                'name': 'å®æ¶æµéæ¾ç¤º',
                'url': 'http://www.google.com',
                'isSwitch': true
            },
            {
                'name': 'ååºç¨æ°´éåæ',
                'url': 'http://www.baidu.com'
            }
        ]
    }, {
        'name': 'çç®¡åæ',
        'url': 'analysis_pipe',
        'chird': null
    }, {
        'name': 'éé¨åæ',
        'url': 'analysis_valve',
        'chird': null
    }];

    hoverId = 0; // å½åå·²éä¸­
    thisMenuId = 0; // å½åéä¸­å­èå

    click(url) {
        this.selectId.emit(url);
    }
    menuSel(i) {
        this.hoverId = i;
        this.thisMenuId = i;
    }

    showSubMenu(i) {
        this.hoverId = i;
        this.thisMenuId = i;
    }

    ngOnInit() {

        this.menuJSON.reverse();
    }

}
